import React from 'react';
import ResendEmailForm from './ResendEmailForm';
import { ToastProvider } from '../../providers/ToastProvider';

export default {
  title: 'Components/PasswordReset/ResendEmailForm',
  component: ResendEmailForm,
  tags: ['autodocs'],
  parameters: {
    layout: 'centered',
  },
  decorators: [
    (Story) => (
      <ToastProvider>
        <div className="p-8 bg-gray-50 min-h-100">
          <Story />
        </div>
      </ToastProvider>
    ),
  ],
};

export const Default = () => <ResendEmailForm />;
